
function openMenu() {
	let burger = document.querySelector('.header_burger');
	let bodyburger = document.querySelector('.body_burger');
	burger.addEventListener('click', () => {
		bodyburger.classList.toggle('open');
		if (bodyburger.classList.contains('open')) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
	})
}
openMenu();

function tema() {
	let light = document.querySelector('.light');
	let body = document.querySelector('.wrapper');
	let form = document.querySelectorAll('.form');
	let svg = document.querySelectorAll('svg *');
	const links = document.querySelectorAll('a');
	let bool = false;

	light.addEventListener('click', () => {
		if (!bool) {
			body.style.backgroundColor = '#263238';
			body.style.color = '#FFFFFF';
			form.forEach((link) => {
				link.style.background = '#FFFFFF';
			});
			links.forEach((link) => {
				link.style.color = '#FFFFFF';
			});
			svg.forEach((element) => {
				// Выполните необходимые действия с каждым элементом
				element.style.fill = '#FFFFFF';
			});
			const randomParam = new Date().getTime();

			light.style.color = '#FFFFFF';
			bool = true;
		} else {

			body.style.backgroundColor = '#FFFFFF';
			body.style.color = '#263238';
			form.forEach((link) => {
				link.style.background = 'rgba(38, 50, 56, 0.1)';
			});
			links.forEach((link) => {
				link.style.color = '#263238';
			});
			svg.forEach((element) => {
				// Выполните необходимые действия с каждым элементом
				element.style.fill = '#263238';
			});
			light.style.color = '#263238';
			bool = false;
		}
	})
}
tema();
function openlink() {
	//let block = document.querySelectorAll('your_content_block_link');
	let item = document.querySelectorAll('.your_content_block_item');


	item.forEach(el => {
		el.addEventListener('click', (event) => {
			let found = event.target.closest('.your_content_block_link');
			if (!found) return;
			let open = found.nextElementSibling;
			console.log(open)
			if (open.dataset.orderState == "close") {
				found.dataset.orderLin = "open";
				open.dataset.orderState = "open";
			} else {
				found.dataset.orderLin = "close";
				open.dataset.orderState = "close";
			}
		});

	})
};

openlink();


function animetion() {
	const aminItems = document.querySelectorAll('._anim-items');

	if (aminItems.length > 0) {
		window.addEventListener('scroll', animOnScrioll);
		function animOnScrioll() {
			for (let index = 0; index < aminItems.length; index++) {
				const animItem = aminItems[index];
				const animItemHeight = animItem.offsetHeight;
				const animItemOffset = offset(animItem).top;
				const animStart = 4;

				let animItemPoint = window.innerHeight - animItemHeight / animStart;

				if (animItemHeight > window.innerHeight) {
					animItemPoint = window.innerHeight - animItemHeight / animStart;
				}
				if ((scrollY > animItemOffset - animItemPoint) && scrollY < (animItemOffset + animItemHeight)) {
					animItem.classList.add('_active');
				} else {
					if (!animItem.classList.contains('_anim-no-hide')) {
						animItem.classList.remove('_active');
					}
				}
			}
		}
		function offset(el) {
			const rect = el.getBoundingClientRect(),
				scrollLeft = window.scrollX || document.documentElement.scrollLeft,
				scrollTop = window.scrollY || document.documentElement.scrollTop;

			return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
		}
		setTimeout(() => {
			animOnScrioll();
		}, 300);

	};
	const words = document.querySelectorAll('span');
	if (words.length > 0) {
		window.addEventListener('scroll', animOnScrioll);
		function animOnScrioll() {
			for (let index = 0; index < words.length; index++) {
				const span = words[index];
				const spanItemHeight = span.offsetHeight;
				const spanItemOffset = offset(span).top;
				const spanStart = 4;

				let spanItemPoint = window.innerHeight - spanItemHeight / spanStart;

				if (spanItemHeight > window.innerHeight) {
					spanItemPoint = window.innerHeight - spanItemHeight / spanStart;
				}
				if ((scrollY > spanItemOffset - spanItemPoint) && scrollY < (spanItemOffset + spanItemHeight)) {
					span.classList.add('bounce-top');
				} else {
					span.classList.remove('bounce-top');

				}
			}
		}
	}

}
animetion();

function viewMore() {
	const button = document.querySelector('.what_content_button');
	const blocks = document.querySelectorAll('.what_content_block');

	blocks.forEach(element => {
		element.style.display = "none";
	})
	blocks[0].style.display = "flex";
	blocks[1].style.display = "flex";



	button.addEventListener('click', () => {
		blocks.forEach(element => {
			element.style.display = "flex";
		})
	})
}
viewMore()


function headeTeleport() {
	let home = document.querySelector('.header_container-big');
	let buttons = document.querySelector('.header_buttons');
	let end = document.querySelector('.body_burger');

	window.addEventListener('resize', function () {
		const viewport_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		if (viewport_width <= 940) {
			end.insertBefore(buttons, end.children[1]);
		}
		else {
			home.insertBefore(buttons, home.children[2]);
		}

	})

}
headeTeleport()